window.N2 = window.N2 || {};

N2.handlers = [];

N2.ready = (callback) => {
  $(document).on("turbolinks:load", callback)
}

N2.unload = (callback) => {
  $(document).on("turbolinks:before-visit", callback)
}

/**
 * bind a handler to document, automatically unbind on TL page nav only do this
 * if your event handler really needs to be present on every page.
 */
N2.bindGlobalHandler = (evt, selector, callback) => {
  $(document).on(evt, selector, callback);
  N2.handlers.push(["global", evt, selector]);
}

// deprecated, use bindGlobalHandler
N2.bindHandler = (evt, selector, callback) => {
  N2.bindGlobalHandler(evt, selector, callback);
}

/**
 * bind an event handler to elements matching selector, automatically unbound
 * on TL page nav.
 */
N2.handle = (evt, selector, callback) => {
  $(selector).on(evt, callback);
  N2.handlers.push(["local", evt, selector]);
}

/**
 * auto unbind all N2.handlers registered events handlers. called on TL page
 * navigation.
 */
N2.unbindHandlers = () => {
  N2.handlers.forEach(function(evtInfo) {
    if (evtInfo[0] == "global") {
      N2.unbindGlobalHandler(evtInfo[1], evtInfo[2]);
    } else {
      N2.offHandle(evtInfo[1], evtInfo[2]);
    }
  });
  N2.handlers = [];
}

// manually unbind global event handler, typically you don't need to use this.
N2.unbindGlobalHandler = (evt, selector) => {
  $(document).off(evt, selector);
}

// manually unbind local event handler, typically you don't need to use this.
N2.offHandle = (evt, selector) => {
  $(selector).off(evt);
}

N2.mergeParams = (params) => {
  let searchParams = new URLSearchParams(window.location.search);
  let url = location.href.split('?')[0]
  for (let [key, value] of Object.entries(params)) {
    searchParams.set(key, value.toString())
  }
  N2.navigate(location.href.split('?')[0] + "?" + searchParams.toString())
}

// Turbolinks API method, wrapped for global usage.
N2.navigate = (location, options) => {
  Turbolinks.visit(location, options);
}

N2.toggleHidden = (ele, show) => {
  if (show) {
    N2.removeHidden(ele);
  } else {
    N2.addHidden(ele);
  }
}

N2.addHidden = (ele) => {
  ele.addClass("hidden");
}

N2.removeHidden = (ele) => {
  ele.removeClass("hidden");
}

/** 
 * Immediately display the page loading indicator, useful for requests you know
 * will be slow to process.
 */
N2.showProgressIndicator = () => {
  Turbolinks.controller.adapter.progressBar.show();
}

N2.hideProgressIndicator = () => {
  Turbolinks.controller.adapter.progressBar.hide();
}

N2.addCSSRule = (rule) => {
  const sheet = document.styleSheets[0];
  const position = sheet.cssRules.length;
  sheet.insertRule(rule, position);
}
